import navigationData from "./generated/navigation-data";
import { routeElementMap, routeRuntimeOverrides } from "./element-map";
import { buildRouteFromData, buildSectionFromData, createAppRoute } from "./schema";

const activeSectionKeyByMenuKey = navigationData.routes.reduce((sectionByMenuKey, route) => {
    if (route.menu === true && route.sectionKey) {
        sectionByMenuKey[route.menuKey || route.key] = route.sectionKey;
    }
    return sectionByMenuKey;
}, {});

export const appNavigationSections = navigationData.sections.map(buildSectionFromData).sort((left, right) => left.order - right.order);

export const appRouteRecords = [
    ...navigationData.routes.map((route) =>
        buildRouteFromData(route, {
            routeElementMap,
            routeRuntimeOverrides,
            activeSectionKeyByMenuKey,
        }),
    ),
    // 货运档案详情（独立档案页，不在侧边栏显示，激活时高亮“货量报告”）
    createAppRoute({
        key: "salesCargoReportArchive",
        path: "/sales/cargo-report/flights/:flightOperationId",
        element: routeElementMap.salesCargoReportArchive,
        layout: "shell",
        routePermission: "sales:cargo:read",
        menu: false,
        activeMenuKey: "salesCargoReport",
        pageLabel: "货运档案",
    }),
];
